import { Component, Inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Shareholder } from '../shareholders-table/shareholder';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  FormFieldList,
  SfAmountInputFormField,
  SfInputFormField,
  SfSelectFormField,
  SfUtils,
  SmartFormComponent,
} from 'ngx-smart-form';
import { PraticaProgressService } from '../../_core/services/pratica-progress.service';
import { SharedModule } from '../../_shared/shared.module';
import { Validators } from '@angular/forms';
import { PersonaGiuridica } from '../models/persona-giuridica';
import { COUNTRIES } from '../../../assets/aml-config/countries';

@Component({
  selector: 'app-shareholder-dialog',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './shareholder-dialog.component.html',
  styleUrls: ['./shareholder-dialog.component.scss'],
})
export class ShareholderDialogComponent {
  @ViewChild(SmartFormComponent)
  smartFormComponent?: SmartFormComponent<Shareholder>;

  fields: FormFieldList<Shareholder> = [
    [
      new SfSelectFormField({
        formControlName: 'type',
        label: 'Tipologia',
        required: true,
        options: [
          {
            value: 'SOCIETA FIDUCIARIE',
            view: "Società fiduciaria non sottoposta a vigilanza da parte di Banca d'Italia",
          },
          {
            value: 'TRUST',
            view: 'Trust o istituti giuridici affini',
          },
          {
            value: 'SOCIETA ANONIME',
            view: 'Società anonime',
          },
          {
            value: 'AZIONI PORTATORE',
            view: 'Società controlla attraverso azioni al portatore',
          },
          {
            value: 'ALTRO',
            view: 'Nessuna delle precedenti',
          },
        ],
      }),
      new SfSelectFormField({
        formControlName: 'country',
        label: 'Paese',
        required: true,
        options: COUNTRIES.map((country) => ({
          value: country.sigla3,
          view: country.view,
        })),
      }),
      new SfAmountInputFormField({
        formControlName: 'share',
        label: '% partecipazione',
        decimals: 2,
        currency: '%',
        required: true,
        validators: [Validators.max(100), Validators.min(0)],
      }),
    ],
  ];

  constructor(
    public dialogRef: MatDialogRef<
      ShareholderDialogComponent,
      Partial<Shareholder>
    >,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      shareholder?: Shareholder;
      personaGiuridica?: PersonaGiuridica;
    },
    public praticaProgressService: PraticaProgressService
  ) {
    SfUtils.assignInitialValue(this.fields, this.data.shareholder);
  }

  ngOnInit(): void {}

  save() {
    this.dialogRef.close(this.smartFormComponent?.formRawValue);
  }
}
